import { ajaxV2 } from '../../helpers';

export const sendClientId = (userId, clientId) => {
  return ajaxV2
    .post('/ga', {user_id: userId, client_id: clientId})
};
